import React from "react";
import { formatDate } from "../../../../../../modules/studentRefund/studentRefundRequest/multiTypeRefund/utils";
import moment from "moment";

const headerStyle = {
  padding: "14px 0",
  fontWeight: 600,
  color: "#3A4351",
  fontSize: "16px",
  borderBottom: "1px solid #E5E7EB",
};

const cellStyle = {
  padding: "18px 0",
  fontSize: "16px",
  color: "#374151",
  borderBottom: "1px solid #F0F0F0",
};

const ActionHistoryTable = ({ data = [] }) => {
    console.log(data)
  return (
    <div style={{ width: "100%" }}>
      {/* Table Header */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 2fr 3fr",
          ...headerStyle,
          fontFamily :"Gilroy-Bold"
        }}
      >
        <div>Action</div>
        <div>Action Reason</div>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          Updated on/by 
        </div>
      </div>

      {/* Rows */}
      {data.map((row, i) => (
        <div
          key={i}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 2fr 3fr",
            ...cellStyle,
          }}
        >
          <div>{row.progAction}</div>
          <div>{row.progReason}</div>
          <div>{moment(row.updatedOn).format('DD/MM/YYYY')} at  {moment(row.updatedOn).format('hh:mm A')} by {row.updatedBy}</div>
        </div>
      ))}
    </div>
  );
};



export default ActionHistoryTable;
